import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getGestoresResults } from '../services/api';

const GestoresContext = createContext();

const GestoresContextProvider = ({ children }) => {
  const [gestores, setGestoresData] = useState(null);
  useEffect(() => {
    const fetchGestoresData = async (mismoPss = true) => {
      try {
        const data = await getGestoresResults(mismoPss);
        console.log(data);
        setGestoresData(data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchGestoresData();
  }, []);

  const contextValue = {
    gestores
  };
  return (
    <GestoresContext.Provider value={contextValue}>
      {children}
    </GestoresContext.Provider>
  );
};


GestoresContextProvider.propTypes = {
  children: PropTypes.node
};

export { GestoresContext,GestoresContextProvider };

